var map = {
	"./default/views/35.08_cam_1/whitebox.jpg": [
		2923,
		2923
	],
	"./default/views/35.08_cam_2/whitebox.jpg": [
		8851,
		8851
	],
	"./default/views/35.08_cam_3/whitebox.jpg": [
		5826,
		5826
	],
	"./default/views/35.08_cam_4/whitebox.jpg": [
		300,
		300
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6740;
module.exports = webpackAsyncContext;